import React, { useState, createContext } from "react";
import { Box } from "@mui/material";

import StaffLoginPage from "./StaffLoginPage";
import SearchMobilePage from "./SearchMobilePage";
import ConfirmationPage from "./ConfirmationPage";

export const StaffPortalContext = createContext();

const StaffPortal = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [data, setData] = useState({});
  const dataValue = {
    currentStep,
    setCurrentStep,
    data,
    setData,
  };

  return (
    <StaffPortalContext.Provider value={dataValue}>
      <Box sx={{ margin: "20px" }}>
        {currentStep === 0 ? (
          <StaffLoginPage />
        ) : currentStep === 1 ? (
          <SearchMobilePage />
        ) : currentStep === 2 ? (
          <ConfirmationPage />
        ) : (
          <></>
        )}
      </Box>
    </StaffPortalContext.Provider>
  );
};

export default StaffPortal;
